import { useCallback, useEffect } from 'react';
import { useLocation } from 'ice';
import { showLoginDrawer, useDrawer } from '@/components/Drawer';
import { EventEmitter } from 'events';
import { debounce } from 'lodash';
import { useStore } from '@/store';
import { useRouter } from '../useRouter';
import { DEVICE_TYPE, ROUTER_MAP } from '@/types';
import { isGuesLogin } from '@/utils/helper';
export const eventEmitter = new EventEmitter();
let idx;
// 自定义钩子
const useAddDrawer = () => {
    // 获取当前的location对象
    const location = useLocation();
    const { device, baseObj } = useStore();
    const isGues = isGuesLogin();

    const { jump } = useRouter();
    // 使用自定义 Hook
    const { showDrawer, drawerPortal, hideDrawer } = useDrawer();
    const handleEvent = useCallback(debounce((message) => {
        const { renderDom, drawerType, props, router } = message;
        // 需要登陆正式会员的
        if ([ROUTER_MAP.CARD_BIND].includes(router)) {
            if (!baseObj.user?.account?.accountId || isGues) {
                showLoginDrawer();
                return;
            }
        }
        // 需要登陆状态即可 访客也可以的
        // 需要登陆正式会员的
        if ([ROUTER_MAP.USER_INDEX].includes(router)) {
            if (!baseObj.user?.account?.accountId) {
                showLoginDrawer();
                return;
            }
        }


        if (device === DEVICE_TYPE.H5 && router) {
            jump(router);
            return;
        }
        showDrawer({ renderDom: renderDom, props: props, drawerType });
    }, 100), [jump, device, showDrawer]);
    useEffect(() => {
        idx?.();

        // 注册监听器
        eventEmitter.on('showDrawer', handleEvent);
        idx = () => {
            eventEmitter.off('showDrawer', handleEvent);
        };
        // 在组件卸载时移除监听器
        return () => {
            eventEmitter.off('showDrawer', handleEvent);
        };
    }, [handleEvent]);

    useEffect(() => {
        hideDrawer?.({ key: false });
    }, [location]);


    return { drawerPortal };
};

export default useAddDrawer;
